import Swiper from 'swiper/bundle';

let photosFromCustomersItems = document.querySelectorAll('.photos-from-customers__photos .photos-from-customers__item a');

for (let item in photosFromCustomersItems) {
    //a bit hacks and magic to run swiper in modal
    if(photosFromCustomersItems[item].classList) {
        photosFromCustomersItems[item].onclick = function(){
            setTimeout(function () {
                let customersGallery = new Swiper('.photos-from-customers__slider', {
                    spaceBetween: 0,
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                    }
                });
            }, 1000);
        };
    }
}

const element = document.querySelector('.photos-from-customers__photos');
if(element){
    let photosCounter = element.childElementCount;

    window.addEventListener('load', photosCount);
    window.addEventListener('resize', photosCount);

    function photosCount() {
        if(window.innerWidth > 600) {
            if(photosCounter > 7) {
                document.querySelector('.photos-from-customers__more').classList.remove('hidden');
                document.querySelector('#extraPhotos').innerText = '+ '+(photosCounter - 7).toString();
            } else {
                const element1 = document.querySelector('.photos-from-customers__more');
                if(element1){
                    element1.classList.add('hidden');
                }
            }
        } else {
            if(photosCounter > 3) {
                document.querySelector('.photos-from-customers__more').classList.remove('hidden');
                document.querySelector('#extraPhotos').innerText = '+ '+(photosCounter - 3).toString();
            } else {
                document.querySelector('.photos-from-customers__more').classList.add('hidden');
            }
        }
    }
}
